import axios from "axios"
import { useQuery } from "@tanstack/vue-query"

const path = "/partner/subordinates"

const useHierarchy = () => {
  const { isFetching, data: subordinates } = useQuery({
    queryKey: ["fetchPartnerSubordinates"],
    async queryFn() {
      const { data } = await axios.get(path)
      return data
    },
    placeholderData: () => ([]),
  })

  return {
    isFetching,
    subordinates,
  }
}

export {
  useHierarchy,
}
